import enUS from "./locales/en-US.json";
import zhCN from "./locales/zh-CN.json";
import type { LocaleBundles } from "./types";

export const BUILTIN_LOCALE_BUNDLES = {
    "zh-CN": zhCN,
    "en-US": enUS,
} satisfies LocaleBundles;

export const BUILTIN_LOCALES = Object.keys(BUILTIN_LOCALE_BUNDLES);
